import type { CSSObject } from '@mui/material/styles';

/** Keep the text in the same flex-item line box across button consumers. */
export const ghostButtonLabelStyles = {
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} as const;

/** GhostButton's established dark primary action. */
export const ghostButtonPrimaryStyles = {
  backgroundColor: 'rgba(28,28,28,0.9)',
  color: 'rgba(255,255,255,0.9)',
  outline: '1px solid rgba(28,28,28,0.9)',
  '&:hover, &:active, &.Mui-focusVisible': {
    backgroundColor: 'rgba(28,28,28,1)',
    boxShadow: 'none',
    outline: '1px solid rgba(28,28,28,1)',
  },
  '&.Mui-disabled': {
    backgroundColor: 'rgba(28,28,28,0.9)',
    color: 'rgba(255,255,255,0.9)',
    outline: '1px solid rgba(28,28,28,0.9)',
    opacity: 0.35,
  },
  '&.Mui-disabled:hover': {
    backgroundColor: 'rgba(28,28,28,0.9)',
    outline: '1px solid rgba(28,28,28,0.9)',
  },
} as const satisfies CSSObject;

/** GhostButton large includes 6 px label padding on each side. */
export const ghostButtonLargeStyles = {
  fontSize: 13,
  height: 28,
  lineHeight: '16px',
  padding: '0 18px',
  '& .MuiButton-startIcon svg, & .MuiButton-startIcon img': {
    width: 14,
    height: 14,
    fontSize: 14,
  },
} as const satisfies CSSObject;
